export const ENCOURS = 'EnCours';
export const VALIDE = 'Validee';
export const TYPE_EDITION_REMISE = 'RemiseBancaire';
export const NATURE_ANNULATION = 'Annulation';
export const NATURE_IMPAYE = 'Impaye';

export const LIST_REMISE_ETAT = [
  { code: ENCOURS, libelle: 'remiseBancaire.dataTable.enCours' },
  { code: VALIDE, libelle: 'remiseBancaire.dataTable.valide' },
];

export const EXPORT_EXCEL_REGLEMENT = 'reglements';
export const EXPORT_EXCEL_REMISE_BANCAIRE_ANNULATION = 'remisebancaireannulation';

export const LISTE_NATURE_REGLEMENT = [
  { code: NATURE_ANNULATION, libelle: 'remiseBancaire.natureReglement.annulation' },
  { code: NATURE_IMPAYE, libelle: 'remiseBancaire.natureReglement.impaye' },
];
